import { render } from "./Effects.vue?vue&type=template&id=6b27d84e&scoped=true"
import script from "../js/effects.js?vue&type=script&lang=js"
export * from "../js/effects.js?vue&type=script&lang=js"

import "./Effects.vue?vue&type=style&index=0&id=6b27d84e&scoped=true&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b27d84e"]])

export default __exports__